<div class="epm-photo-upload-widget-container">
  <div>
    <div *ngIf="hasFile" fxLayout="column" fxLayoutAlign="center">
      <div *ngFor="let photo of photosData; let i = index" class="epm-photo-item-wrapper">
        <p>{{ photo.taskName }}</p>
        <img [src]="photo.url" alt="Issue photo" width="100%">
        <button *ngIf="!field.readOnly && photosRemovable[i] && allowPreviousFileRemoval(photo.url)" mat-icon-button [id]="'file-'+photo.url+'-remove'" class="remove-button" color="warn" (click)="removeFile(photo.url);" (keyup.enter)="removeFile(photo.url);">
          <mat-icon class="mat-24">highlight_off</mat-icon>
        </button>
        <div>
          <button *ngIf="!isEditing && isEditable && photosEditable[i]" mat-icon-button [id]="'file-'+photo.url+'-edit'" class="edit-button" color="primary" (click)="editPhoto(photo.url)" (keyup.enter)="editPhoto(photo.url)">
            <mat-icon class="mat-24">edit</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="(!hasFile || multipleOption) && !field.readOnly">
    <button mat-raised-button color="primary" (click)="uploadFiles.click()" type="button" [matTooltip]="field.tooltip"
            matTooltipPosition="above" matTooltipShowDelay="1000">
      {{ 'EPM.PHOTO_UPLOAD' | translate }}<mat-icon>file_upload</mat-icon>
    </button>
    <input #uploadFiles type="file" accept="image/*"
           [multiple]="multipleOption" [id]="field.form.nodeId"
           (change)="onFileChanged($event)" style="display: none;">
  </div>
  <div *ngIf="isEditing" class="button-container display-none">
    <button class="save-button" type="button" (click)="saveEdit()">{{ 'SAVE' | translate }}</button>
    <button class="close-button" type="button" (click)="cancelEdit()">{{ 'CLOSE' | translate }}</button>
    <div class="color-buttons display-none">
      <button class="color-button" type="button" *ngFor="let color of colors" [style.backgroundColor]="color" (click)="changeColor(color)"></button>
    </div>
  </div>
</div>
